import { Ticket, PartyPopper, MapPin, Music2, Users, Clock } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "../../components/Reveal";
import { Eyebrow, Button } from "../../components/Bits";
import { TICKET_URL, EVENT_DATE, EVENT_LOCATION } from "./prideData";

const plan = [
  { icon: Users, title: "The parade", body: "The day opens with our colourful Pride parade through Whitehaven, ending on the harbour. Everyone is welcome to walk with us." },
  { icon: PartyPopper, title: "Harbourside festival", body: "Free stalls, street food, family activities and entertainment fill the harbourside throughout the afternoon." },
  { icon: Music2, title: "Main arena", body: "Our headline lineup takes to the main stage. A ticket (just £3.99) gets you into the arena for the full show." },
];

export default function PrideWhatsOn() {
  return (
    <div>
      <section className="container-x py-16 md:py-20">
        <Reveal>
          <Eyebrow className="text-nead-pink">What's on</Eyebrow>
          <h1 className="mt-4 font-display font-bold text-4xl sm:text-5xl tracking-tight text-nead-navy">A full day of colour and community.</h1>
          <p className="mt-5 max-w-2xl text-lg text-nead-navy/65 leading-relaxed">
            Pride by the Harbourside closes the Whitehaven Weekender on {EVENT_DATE}, at {EVENT_LOCATION}. Entry to the festival and parade is free, with tickets only needed for the main arena.
          </p>
        </Reveal>

        <Stagger className="mt-12 grid md:grid-cols-3 gap-6">
          {plan.map((p) => (
            <StaggerItem key={p.title}>
              <div className="h-full rounded-[1.5rem] border border-black/[0.07] p-8">
                <div className="flex h-12 w-12 items-center justify-center rounded-full grad-pink-cyan"><p.icon className="h-6 w-6 text-white" strokeWidth={1.8} /></div>
                <h3 className="mt-6 font-display font-bold text-xl text-nead-navy">{p.title}</h3>
                <p className="mt-3 text-nead-navy/60 leading-relaxed">{p.body}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </section>

      <section className="bg-nead-mist">
        <div className="container-x py-16 md:py-20">
          <div className="grid lg:grid-cols-3 gap-6">
            <div className="rounded-[1.5rem] bg-white border border-black/[0.07] p-8">
              <PartyPopper className="h-6 w-6 text-nead-pink" />
              <h3 className="mt-4 font-display font-bold text-lg text-nead-navy">Free festival &amp; parade</h3>
              <p className="mt-2 text-nead-navy/60 text-[0.95rem] leading-relaxed">The parade, harbourside stalls and street celebrations are completely free for everyone.</p>
            </div>
            <div className="rounded-[1.5rem] bg-white border border-black/[0.07] p-8">
              <Ticket className="h-6 w-6 text-nead-pink" />
              <h3 className="mt-4 font-display font-bold text-lg text-nead-navy">Main arena, just £3.99</h3>
              <p className="mt-2 text-nead-navy/60 text-[0.95rem] leading-relaxed">Tickets are only needed for the main arena. Every ticket helps fund NEAD's community work.</p>
              <a href={TICKET_URL} target="_blank" rel="noreferrer" data-testid="whatson-tickets" className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-nead-pink hover:underline">Book arena tickets <Ticket className="h-4 w-4" /></a>
            </div>
            <div className="rounded-[1.5rem] bg-white border border-black/[0.07] p-8">
              <Clock className="h-6 w-6 text-nead-pink" />
              <h3 className="mt-4 font-display font-bold text-lg text-nead-navy">Timings</h3>
              <p className="mt-2 text-nead-navy/60 text-[0.95rem] leading-relaxed">Full stage times and the running order will be announced closer to the event. Check back soon.</p>
            </div>
          </div>
          <div className="mt-10 flex flex-wrap gap-3">
            <Button to="/pride/lineup" variant="pink" testId="whatson-lineup">See the lineup</Button>
            <Button to="/pride/visit" variant="outline" testId="whatson-visit">Plan your visit</Button>
          </div>
        </div>
      </section>
    </div>
  );
}
